import type { Flag, FlagId, FlagInstanceId } from '../types.tsx';

export type ShowPayload = Flag;

export const SHOW = 'state.SHOW' as const;
export type ShowAction = {
	type: typeof SHOW;
	payload: ShowPayload;
};
export const show = (payload: ShowPayload): ShowAction => ({
	type: SHOW,
	payload,
});

export const DISMISS_INSTANCE = 'state.DISMISS_INSTANCE' as const;
export type DismissAction = {
	type: typeof DISMISS_INSTANCE;
	payload: FlagInstanceId;
};
export const dismiss = (payload: FlagInstanceId): DismissAction => ({
	type: DISMISS_INSTANCE,
	payload,
});

export const DISMISS_FLAG = 'state.DISMISS_FLAG' as const;
export type DismissFlagAction = {
	type: typeof DISMISS_FLAG;
	payload: FlagId;
};
export const dismissFlagAction = (payload: FlagId): DismissFlagAction => ({
	type: DISMISS_FLAG,
	payload,
});

export const RESET = 'state.RESET' as const;
export type ResetAction = {
	type: typeof RESET;
};
export const reset = (): ResetAction => ({
	type: RESET,
});
